import { useApolloClient, useMutation } from "@vue/apollo-composable";
import type { CustomerFragmentFragment } from "@/api/generated/graphql";
import {
  CustomerDocument,
  CustomerFragmentFragmentDoc,
  RequestMobileVerificationDocument,
  VerifyMobileDocument,
} from "@/api/generated/graphql";
import { useFragment } from "@/api/generated";

export const customerQuery = CustomerDocument;

export async function fetchCustomer(): Promise<CustomerFragmentFragment> {
  const { resolveClient } = useApolloClient();
  const client = resolveClient();
  const result = await client.query({ query: customerQuery });
  const customer = useFragment(CustomerFragmentFragmentDoc, result.data.customer);

  if (!customer) {
    throw new Error("No customer returned");
  }

  return customer;
}

export async function requestMobileVerificationCode({ mobile }: { mobile: string }) {
  const { onDone, onError, mutate } = useMutation(RequestMobileVerificationDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ mobile });
  return res;
}

export async function verifyMobileWithCode({ mobile, verificationCode }: { mobile: string; verificationCode: string }) {
  const { onDone, onError, mutate } = useMutation(VerifyMobileDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ mobile, verificationCode });
  return res;
}
